import { render } from "./recipientsView.vue?vue&type=template&id=0941b9f0&scoped=true"
import script from "./recipientsView.vue?vue&type=script&lang=js"
export * from "./recipientsView.vue?vue&type=script&lang=js"

import "./recipientsView.vue?vue&type=style&index=0&id=0941b9f0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0941b9f0"]])

export default __exports__